export default __webpack_public_path__ + "static/media/chat.f2ffff56.png";